<template>
  <div class="status-summary-bar d-flex flex-wrap align-items-stretch mb-6">
    <button
      v-for="s in statusCounts"
      :key="s.status"
      type="button"
      class="status-chip text-left mr-3 mb-3 p-3 rounded"
      :class="chipClass(s.status)"
      @click="$emit('filter', activeStatus === s.status ? null : s.status)"
    >
      <div class="status-chip-count font-weight-bolder">{{ s.count }}</div>
      <div class="status-chip-label font-weight-bold text-uppercase">{{ s.status }}</div>
    </button>
  </div>
</template>

<script>
export default {
  name: "StatusSummaryBar",

  props: {
    // Array of { status, count, variant } in operational order.
    statusCounts: {
      type: Array,
      required: true
    },
    activeStatus: {
      type: String,
      default: null
    }
  },

  methods: {
    chipClass: function(status) {
      const active = this.activeStatus === status;
      const isException = status === "Exception";
      if (active) {
        return isException ? "chip-active-exception" : "chip-active";
      }
      return isException ? "chip-idle-exception" : "chip-idle";
    }
  }
};
</script>

<style lang="scss" scoped>
.status-chip {
  min-width: 140px;
  border: 1px solid #e4e6ef;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;
}

.status-chip:hover {
  border-color: #3699ff;
}

.status-chip-count {
  font-size: 1.5rem;
  line-height: 1.1;
  color: #181c32;
}

.status-chip-label {
  font-size: 0.75rem;
  color: #7e8299;
}

.chip-active {
  border-color: #3699ff;
  background-color: #e1f0ff;
}

.chip-active .status-chip-count,
.chip-active .status-chip-label {
  color: #187de4;
}

.chip-idle-exception {
  border-color: #ffa800;
  background-color: #fff4de;
}

.chip-idle-exception .status-chip-count {
  color: #ee9d01;
}

.chip-active-exception {
  border-color: #ffa800;
  background-color: #ffe9bf;
}

.chip-active-exception .status-chip-count,
.chip-active-exception .status-chip-label {
  color: #ee9d01;
}
</style>
